import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@i18n';
import { ExpiredSessionModal } from './components';
import { useController } from './hooks';

export const SessionKeeper = ({ children = null }) => {
  const {
    email,
    showModal,
    description,
  } = useController();

  return (
    <>
      {children}
      {showModal ? (
        <ExpiredSessionModal
          isOpen
          email={email}
          title={t('SignIn.anotherDeviceModal.title')}
          description={description}
        />
      ) : null}
    </>
  );
};

SessionKeeper.propTypes = {
  children: PropTypes.node,
};
